<template>
    <div class="footer" id="app-footer">
      <!-- 通用底部 -->
        <div class="left">
          <div class="imgs">
            <!-- <img class="ios" src="../assets/images/footer_ios.png" alt=""> -->
            <!-- <img class="google" src="../assets/images/footer_google.png" alt=""> -->
          </div>
          <!-- <div class="intro">北京外国语大学  外语教学与研究出版社  教育部全国青少年普法网运营中心</div> -->
        </div>
        <div class="right">
          <div class="tab">
            <!-- <div :class="(item.checked? 'list checked' : 'list')" v-for="(item,index) in list" :key="index"  @mouseover="changeHover(index)" @click="toDetail(index)">{{item.name}}</div> -->
          </div>
       <div class="bottom">京ICP备16013132号-2</div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'app-footer',
    data () {
      return {
        list:[{name:'关于我们',checked:true,},
          {name:'联系我们',checked:false,},
          {name:'帮助中心',checked:false,},
          {name:'隐私说明',checked:false,},
          {name:'版权声明',checked:false,},
        ]
      }
    },
    methods:{
      changeHover(index){
        this.list.forEach((v,k)=>{
          if(index == k){
            if(!v.checked){
               v.checked = true;
            }
          }else{
            v.checked = false;
          }
        })
      },
      toDetail(index){
        if(index == 0){
          this.$router.push('/AboutUs');
        }else if(index == 2){
          this.$router.push('/Help');
        }
      },
    }
  }
</script>
<style scoped>
.footer{
  width: 100%;
  height: 1.6rem;
  margin: 0 auto;
  background-color: #f8f8f8;
}
.left{
  float: left;
  width: 7.7rem;
}
.left .imgs{
  width: 100%;
  float: left;
  margin-top: 0.3rem;
}
.left .ios{
  float: left;
  width: 1.35rem;
  height: 0.4rem;
  margin-left: 0.34rem;
}
.left .google{
  float: left;
  width: 1.4rem;
  height: 0.42rem;
  margin-left: 0.34rem;
}
.left .intro{
  float: left;
  margin: 0.28rem 0 0 0.3rem;
  font-size: 0.21rem;
  color: #6e6e6e;
  font-weight: 700;
}
.right{
  float: right;
   width: 7.3rem;
}
.right .tab{
  width: 100%;
  height: 0.4rem;
  margin-top: 0.35rem;
}
.right .tab .list{
  float: left;
  font-size: 0.25rem;
  height: 0.4rem;
  line-height: 0.3rem;
  margin-left: 0.35rem;
  color: #6e6e6e;
  cursor:pointer;
}
.right .tab .checked{
  border-bottom: 0.05rem solid #0073d3;
}
.right .bottom{
  float: right;
  font-size: 0.17rem;
  color: #6e6e6e;
  margin: 0.35rem 0.44rem 0 0;
  font-weight: 700;
}


.footer{
  width: 100%;
  height: 1.7rem;
  background-color: #2b2b2b;
  /* margin-top: 0.42rem; */
}
.footer .container{
  width: 12rem;
  height: 100%;
  margin: 0 auto;
}
.footer .container .top{
  font-size: 0.14rem;
  line-height: 0.14rem;
  color: #fff;
  padding-top: 0.45rem;
}
.footer .container .topdy{
  font-size: 0.14rem;
  line-height: 0.14rem;
  color: #fff;
  padding-left: 6.55rem;
  padding-top: -0.40rem;
}
.footer .container .topqq{
  font-size: 0.14rem;
  line-height: 0.14rem;
  color: #fff;
  padding-left: 8.55rem;
  padding-top: -0.40rem;
}
.footer .container .cen{
  font-size: 0.14rem;
  line-height: 0.14rem;
  color: #fff;
  margin-top: 0.21rem;
}
.footer .container .bot{
  font-size: 0.14rem;
  line-height: 0.14rem;
  color: #fff;
  margin-top: 0.21rem;
}
.footer_right_img {
  position: fixed;
  right: 30px;
  bottom: 50px;
  z-index: 9;
  width: 200px;
  /* height: 200px; */
}
.footer_right_img_box {
  position: relative;
}
.footer_right_img .close {
  width: 20px;
  position: absolute;
  top: -30px;
  right: 0;
  cursor: pointer;
  /* height: 100%; */
}
.footer_right_img .code {
  width: 100%;
  /* height: 100%; */
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue